<template lang="pug">
section.signup.full__video.noBoxShadow
  .fluid__video.splash.form__video--horizontal
    iframe(src='https://media.flixel.com/cinemagraph/mv7tif44u6c1vm9e30cs' allow='autoplay')
  .fluid__video.splash.form__video--vertical
    iframe(src='https://media.flixel.com/cinemagraph/ab06d2jrwa3ppzhdym0h?hd=true' allow='autoplay')  
    .credit
      a(target='_blank' href='https://flixel.com/jimmycheung/') Jimmy Cheung
  .signup__form
    .message.error(v-show='errorModal')
      p {{ newUserError }}
      a.close(@click='errorModal = false')
    form(name='registrationForm', v-on:submit.prevent='registerUser(newUser)')
      .ui-input

        h1 Create an account to get started
        .message.informational(v-if='redirectUrl')
          p After login you will be redirected to the Flixel Store

        p Username
        p.small-type(v-if='userNameError') Username can only contain letters, numbers and '_'
        input(
          type='text',
          name='username',
          v-model='newUser.username',
          placeholder='Choose a username',
          required)

        p Email
        input(
          type='text',
          name='email',
          v-model='newUser.email',
          placeholder='Your email',
          required)

        p Password
        input(
          type='password',
          name='password',
          v-model='newUser.password',
          placeholder='Choose a password',
          required)

        .marketingConsent--container
          label.checkbox--container
            input(
              type='checkbox',
              v-model='newUser.marketing_consent',
            )
            span.checkmark
            p Marketing Consent
          .subtext
            p Flixel can send me product updates and offers via email. You can opt-out at any time.

        button.btn.btn--purpleLight(type='submit') Register
        p
          router-link.link(to="/login/") Already have an account?
</template>

<script>
import { _ } from 'vue-underscore';
import AuthService from 'services/auth.es6.js';
import AccountService from 'services/account.es6.js';
import ProfileService from 'services/profile.es6.js';
import UtilitiesService from 'services/utilities.es6.js';

export default {
  name: 'Register',
  data() {
    return {
      error: null,
      loading: false,
      errorModal: false,
      newUserError: '',
      userNameError: null,
      redirectUrl: null,
      newUser: {
        username: null,
        email: null,
        password: null,
        marketing_consent: null,
      },
    };
  },
  metaInfo: {
    title: 'Create Cinemagraphs Easily | Cinemagraph Pro | Flixel',
    meta: [
      {
        'property': 'image',
        'content': 'https://cdn.flixel.com/static/static-web/Registration.png',
      },
      {
        'property': 'description',
        'content': 'Start creating cinemagraphs with the best cinemagraph app, Cinemagraph Pro. Sign up with Flixel today!',
      },
    ],
  },
  methods: {

    /*
    * Validation
    */

    validateUserName(username) {
      const usernameRegex = UtilitiesService.regValidUsername();
      return usernameRegex.test(username);
    },

    validateForm(form) {
      if (!this.validateUserName(form.username)) {
        this.userNameError = true;
      } else {
        this.userNameError = false;
      }
    },

    /**
    * Private
    */

    registerNewUserSuccess(data) {
      AuthService.updateUser('account', data.data);
      ga('send', 'event', 'Register', 'Button Click', 'Register');
    },

    registerNewUserError(error) {
      this.errorModal = true;
      this.newUserError = error;
      this.loading = false;
      return Promise.reject(error);
    },

    registerNewUserInvoke(user) {
      this.loading = true;
      return AccountService.register(user)
        .then(this.registerNewUserSuccess, this.registerNewUserError);
    },

    getAccessTokenSuccess(data) {
      AuthService.storeAccessToken(data);
    },

    getAccessTokenError(error) {
      this.errorModal = true;
      this.newUserError = AuthService.rejectAccessToken(error);
      this.loading = false;
      return Promise.reject(error);
    },

    getAccessTokenInvoke() {
      const userCredentials = _.omit(this.newUser, 'email');
      return AuthService.getAccessToken(userCredentials)
        .then(this.getAccessTokenSuccess, this.getAccessTokenError);
    },

    getProfileSuccess(data) {
      AuthService.updateUser('profile', data);
      this.$router.push({ name: 'Profile', params: { username: data.realname } });
    },

    getProfileError(error) {
      return Promise.reject(error);
    },

    getProfileInvoke() {
      ProfileService.get(this.newUser.username)
        .then(this.getProfileSuccess, this.getProfileError);
    },

    /**
     * Methods used in view
     */

    registerUser(user) {
      this.validateForm(user);

      if (!user.marketing_consent) {
        user.marketing_consent = false;
      }
      if (user.password.length < 6) {
        this.errorModal = true;
        this.newUserError = 'Password must be a minimum of 6 characters.';
      } else {
        this.registerNewUserInvoke(user)
          .then(this.getAccessTokenInvoke)
          .then(this.getProfileInvoke);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/auth/Register.vue